
import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin';
import ProjectTitle from './ProjectTitle';

const ProjectEdit = props => (
    <Edit title={<ProjectTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
            <ReferenceInput label="Instance" source="instance_id" reference="instances">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export default ProjectEdit;